import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { ListGroup } from 'react-bootstrap';

import { Icon, IconWiFiSignal } from '../../../Atoms/Icon';

import BadgeLoader from './BadgeLoader';

const NetworkList = ({
  networks,
  readOnly,
  loading,
  selectedSsid,
  openSecurityModes,
  onConnectNetwork,
}) => {
  if (networks.length === 0)
    return (
      <ListGroup>
        <ListGroup.Item variant="light">Not available</ListGroup.Item>
      </ListGroup>
    );

  return (
    <ListGroup>
      {networks.map((network) => {
        return (
          <ListGroup.Item
            action
            disabled={network.connected || readOnly}
            key={network.ssid}
            onClick={() => onConnectNetwork(network)}
          >
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                {selectedSsid === network.ssid && loading ? (
                  <BadgeLoader />
                ) : (
                  <IconWiFiSignal
                    signalStrength={network.signalStrengthNormalized}
                    className={classNames(
                      'h3 mb-0',
                      network.connected ? 'text-success' : 'text-gray-200',
                    )}
                    variant={network.connected ? 'outline' : 'filled'}
                  />
                )}
                <span className="ml-2">{network.ssid}</span>
              </div>
              {!openSecurityModes.includes(network.security.toUpperCase()) && (
                <Icon
                  name="lock-locked"
                  className="text-gray small"
                  role="status"
                />
              )}
            </div>
          </ListGroup.Item>
        );
      })}
    </ListGroup>
  );
};

export default NetworkList;

NetworkList.propTypes = {
  onConnectNetwork: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  networks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  openSecurityModes: PropTypes.arrayOf(PropTypes.string),
  readOnly: PropTypes.bool.isRequired,
  selectedSsid: PropTypes.string,
};
